var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcluded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1256 6.89816H0V0H21.1256V6.89816ZM1.00598 5.89218H20.1196V1.00598H1.00598V5.89218Z",
    fill: "#B33939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 15.3771H22.4189V14.5148H22.9938V13.9399H23.9998V15.3771Z",
    fill: "#B33939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5507 15.3771H18.6825V14.3711H20.5507V15.3771ZM16.8142 15.3771H14.946V14.3711H16.8142V15.3771ZM12.934 15.3771H11.0658V14.3711H12.934V15.3771ZM9.0538 15.3771H7.18555V14.3711H9.0538V15.3771Z",
    fill: "#B33939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.317 15.3771H3.87988V13.9399H4.88586V14.5148H5.317V15.3771Z",
    fill: "#B33939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88586 11.353H3.87988V12.6464H4.88586V11.353Z",
    fill: "#B33939"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88586 10.0598H3.87988V8.479H5.317V9.48499H4.88586V10.0598Z",
    fill: "#B33939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5507 9.48499H18.6825V8.479H20.5507V9.48499ZM16.8142 9.48499H14.946V8.479H16.8142V9.48499ZM12.934 9.48499H11.0658V8.479H12.934V9.48499ZM9.0538 9.48499H7.18555V8.479H9.0538V9.48499Z",
    fill: "#B33939"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 10.0598H22.9938V9.48499H22.4189V8.479H23.9998V10.0598Z",
    fill: "#B33939"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 11.353H22.9941V12.6464H24.0001V11.353Z",
    fill: "#B33939"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1256 23.9997H0V17.1016H21.1256V23.9997ZM1.00598 22.9937H20.1196V17.9638H1.00598V22.9937Z",
    fill: "#B33939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluded);
export default __webpack_public_path__ + "static/media/excluded.520056ce.svg";
export { ForwardRef as ReactComponent };